export default "/fonts/hotelspace.woff?053fa988fdf2c0485f41f92cf0e64b12";